import React from 'react';
import { Button, Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import { formatDateToEDTRrEST } from '@utils/widget';
import { BuyerTargetInfo } from '@components';
import ManualOrAutoSwicher from './manualOrAutoSwicher';
import { useSelector } from 'react-redux';

// import PropTypes from 'prop-types';

const ExpandBtnLeft = ({ handleToggleExpand }) => (
  <span
    className="appkiticon icon-menu-fill a-font-24 expand-switch-controller"
    onClick={() => handleToggleExpand((e) => !e)}
  />
);

const ExpandBtnRight = ({
  handleToggleExpand,
  show = true,
  isExpand,
  hideTitle,
}) => (
  <div className="expand-btn-right" onClick={handleToggleExpand}>
    {!hideTitle && <span className="text"> Learn More</span>}
    {show && (
      <span
        className={`appkiticon icon-${isExpand ? 'up' : 'down'}-chevron-fill`}
      />
    )}
  </div>
);

const isOverAll = (section) => section === 'overall';

function SectionHeader(props) {
  const {
    title,
    lastEditAt,
    lastEditBy,
    onEdit,
    onSave,
    isEditing,
    handleLeftExpand,
    handleRightExpand,
    section,
    isLoading,
    isRightExpand,
    canSave,
    changeMode,
    currentMode,
    currentSection,
  } = props;
  const history = useHistory();
  const isOverall = currentSection === 'overall';
  const userInfo = useSelector((state) => state.login.userInfo);
  const isAdmin = userInfo.isAdmin;

  const handleReviewBtnClick = () => {
    if (isOverAll(section)) {
      history.push('/questionnaires');
    } else {
      history.push(`/questionnaires/review-responses#${section}`);
    }
  };
  const editButton = (
    <Button
      className="edit-btn"
      loading={isLoading}
      danger
      size="middle"
      onClick={onEdit}
    >
      <span style={{ 'margin-right': '2px' }}>edit</span>
      {isAdmin && currentMode === 'auto' && (
        <span className="appkiticon icon-information-fill" />
      )}
    </Button>
  );
  return (
    <div className="complexity-section-header-wrapper">
      <div className="complexity-sider-switcher-wrapper">
        <ExpandBtnLeft handleToggleExpand={handleLeftExpand} />
        <ExpandBtnRight
          handleToggleExpand={handleRightExpand}
          section={section}
          isExpand={isRightExpand}
        />
        <BuyerTargetInfo />
      </div>
      <div className="complexity-section-header">
        <span className="complexity-section-title">{title}</span>
        {!isOverall && isEditing ? (
          <div style={{ 'text-align': 'end' }}>
            <Button
              loading={isLoading}
              className="edit-btn"
              danger
              size="middle"
              onClick={onEdit}
            >
              cancel
            </Button>

            {canSave ? (
              <Button
                loading={isLoading}
                size="middle"
                type="primary"
                onClick={onSave}
              >
                save
              </Button>
            ) : (
              <Tooltip
                className="complexity-header-tooltip"
                placement="topRight"
                title="You cannot save with uncompleted questions"
                trigger="hover"
              >
                <Button
                  loading={isLoading}
                  size="middle"
                  type="primary"
                  onClick={onSave}
                  disabled={true}
                >
                  save
                </Button>
              </Tooltip>
            )}
          </div>
        ) : (
          isAdmin &&
          !isOverall && (
            <div className="complexity-header-button-group role-control">
              {isAdmin && currentMode === 'auto' ? (
                <Tooltip
                  placement="bottom"
                  title="The changes made will be reflected in all new projects created and updated in existing projects that have not submitted the Questionnaire."
                  overlayClassName="subs-info-tooltip"
                >
                  {editButton}
                </Tooltip>
              ) : (
                editButton
              )}
              <Button
                size="middle"
                loading={isLoading}
                type="primary"
                onClick={handleReviewBtnClick}
              >
                See Responses
              </Button>
            </div>
          )
        )}
      </div>
      {isOverAll(section) && lastEditAt && (
        <span className="complexity-section-lastedit">
          {formatDateToEDTRrEST(lastEditAt, lastEditBy)}
        </span>
      )}
      <ManualOrAutoSwicher
        onChange={changeMode}
        currentMode={currentMode}
        disabled={isEditing}
        isOverall={isOverall}
      />

      <div className="risk-header">
        <ExpandBtnRight show={false} section={section} hideTitle />
      </div>
    </div>
  );
}

SectionHeader.propTypes = {};

export default SectionHeader;
